import React from "react";

export default function About() {
  return (
    <section className="section section-light">
      <div className="container">
        <div
          className="eyebrow"
          style={{ textAlign: "center", marginBottom: "0.6rem", color: "#7a4dff" }}
        >
          Hola, soy
        </div>
        <h2
          className="h2-section"
          style={{
            textAlign: "center",
            color: "#0a0a0a",
            marginBottom: "2.5rem",
          }}
        >
          Judit <span className="serif-italic hl-purple-strong">Català</span>.
        </h2>

        <div
          className="about-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "minmax(280px, 460px) 1fr",
            gap: "3rem",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              borderRadius: 22,
              aspectRatio: "1 / 1",
              position: "relative",
              overflow: "hidden",
              background: "#1a1a1a",
              boxShadow: "0 30px 60px -25px rgba(0,0,0,0.25)",
              width: "100%",
            }}
          >
            <img
              src="/judit.jpg"
              alt="Judit Català"
              style={{
                width: "100%",
                height: "100%",
                position: "absolute",
                inset: 0,
                objectFit: "cover",
                objectPosition: "center 25%",
              }}
              onError={(e) => {
                e.currentTarget.outerHTML =
                  '<div style="height:100%;display:flex;align-items:center;justify-content:center;color:#8a5a6a;font-family:Playfair Display,serif;font-size:2rem;font-style:italic;">Judit Català</div>';
              }}
            />
          </div>

          <div>
            <p
              style={{
                color: "#222",
                fontSize: "1.08rem",
                lineHeight: 1.7,
              }}
            >
              Llevo más de <strong>15 años</strong> ayudando a creadores y
              emprendedores a transformar su contenido en clientes reales. En
              los últimos 5 meses he pasado de{" "}
              <strong>100.000 a +950.000 seguidores</strong> aplicando el mismo
              método que voy a enseñarte en esta clase — y he facturado más de{" "}
              <strong>10M€</strong> directamente desde redes.
            </p>
            <p style={{ color: "#444", marginTop: "1rem", lineHeight: 1.7 }}>
              En esta primera clase de{" "}
              <span className="serif-italic hl-purple-strong">
                Ventas Virales
              </span>{" "}
              te abro la puerta a mi sistema completo. Es la primera del
              programa y la comparto contigo para que veas, sin filtros, cómo
              funciona por dentro y decidas si quieres entrar conmigo.
            </p>

            <div
              className="grid-2"
              style={{ marginTop: "1.6rem", gap: "0.9rem" }}
            >
              <div className="card-light" style={{ textAlign: "center" }}>
                <div className="price-tag" style={{ color: "#0a0a0a" }}>
                  +950K
                </div>
                <div
                  style={{
                    color: "#666",
                    textTransform: "uppercase",
                    letterSpacing: "0.18em",
                    fontSize: "0.72rem",
                    marginTop: "0.3rem",
                  }}
                >
                  Seguidores en 5 meses
                </div>
              </div>
              <div className="card-light" style={{ textAlign: "center" }}>
                <div className="price-tag" style={{ color: "#0a0a0a" }}>
                  10M€+
                </div>
                <div
                  style={{
                    color: "#666",
                    textTransform: "uppercase",
                    letterSpacing: "0.18em",
                    fontSize: "0.72rem",
                    marginTop: "0.3rem",
                  }}
                >
                  Facturados en redes
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>{`
        @media (max-width: 900px) {
          .about-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
